import {
	Component,
	ElementRef,
	HostBinding,
	Input,
	OnDestroy,
	inject
} from '@angular/core';

import { MaxWidthSmallMediaQuery } from 'rev-shared/ui/size/Size.Constants';
import { MediaQueryService } from 'rev-shared/ui/size/MediaQuery.Service';
import { Subscription } from 'rxjs';

type Styles = { customMobileBreakPoint: string; customBreakPointReached: string };

@Component({
	selector: 'vb-ui-base-sidebar',
	template: '',
	standalone: false
})
export class VbUiBaseSidebarComponent implements OnDestroy {
	@Input() public isMobileLayoutDisabled: boolean;
	@Input() public mobileLayoutBreakPointSize: number;

	public isMobileWindow: boolean;
	protected mediaQuery: string;
	private subscription: Subscription;

	private readonly MediaQueryService: MediaQueryService = inject(MediaQueryService);
	private readonly elementRef: ElementRef = inject(ElementRef);
	private mediaQueryStyles: Styles;

	public initMediaQuerySubscription(styles: Styles): void {
		this.mediaQueryStyles = styles;
		if (this.mobileLayoutBreakPointSize) {
			this.elementRef.nativeElement.style.setProperty('--sidebar-mobile-layout-break', this.mobileLayoutBreakPointSize + 'px');
			this.mediaQuery = `(max-width: ${this.mobileLayoutBreakPointSize - 1}px)`;
			this.elementRef.nativeElement.classList.add(styles.customMobileBreakPoint);
		}

		this.subscription = this.MediaQueryService.getObservable(this.mediaQuery || MaxWidthSmallMediaQuery)
			.subscribe(matches => this.onMobileMediaQueryChange(matches));

	}

	public ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	@HostBinding('attr.layout')
	public get layout(): string {
		return this.isMobileWindow ? 'column' : 'row';
	}

	protected onMobileMediaQueryChange(matches: boolean): void {
		if (this.mobileLayoutBreakPointSize) {
			this.elementRef.nativeElement.classList.toggle(this.mediaQueryStyles.customBreakPointReached, matches);
		}

		this.isMobileWindow = !this.isMobileLayoutDisabled && matches;
	}
}
